import { h } from 'preact'; /** @jsx h */
import './Spinner.css';

const Spinner = ({ size, color = '#676767' }) => {
    return (
        <svg className="spinner" viewBox="0 0 50 50" width={size} height={size}>
            <circle
                className="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                // eslint-disable-next-line react/no-unknown-property
                stroke-width="5"
                stroke={color}
            ></circle>
        </svg>
    );
};

export default Spinner;
